module.exports = __webpack_public_path__ + "static/img/logo2.251a8492.png";